module.exports = __webpack_public_path__ + "img/novonordisk.dbebb17b.svg";